<template>
  <div :class="['task-exam-page', { 'task-exam-page--ready': pageReady }]">
    <div v-if="pageLoading" class="exam-loading-wrap panel-card">
      <div class="exam-loading-wrap__icon">
        <i class="el-icon-loading"></i>
      </div>
      <div class="exam-loading-wrap__title">考试数据加载中</div>
      <div class="exam-loading-wrap__desc">正在准备试卷、题目和考试状态，请稍候...</div>
      <div class="exam-loading-skeleton">
        <span class="exam-loading-skeleton__block exam-loading-skeleton__block--lg"></span>
        <span class="exam-loading-skeleton__block"></span>
        <span class="exam-loading-skeleton__block"></span>
        <span class="exam-loading-skeleton__block exam-loading-skeleton__block--sm"></span>
      </div>
    </div>

    <div v-else class="exam-shell">
      <section v-if="examFlow === 'notice'" class="exam-intro-layout">
        <div class="panel-card intro-card exam-stage exam-stage--hero">
          <div class="intro-card__topbar">
            <!-- <el-button plain size="mini" icon="el-icon-arrow-left" @click="goTaskList">返回我的任务</el-button> -->
            <span class="status-pill status-pill--pending">待开始</span>
          </div>

          <div class="section-eyebrow">EXAM NOTICE</div>
          <h1 class="page-title">{{ pageTitle }}</h1>
          <p class="page-desc">
            请先阅读考试说明，确认设备、网络和作答环境正常后，再进入正式考试。
          </p>

          <div class="exam-summary-grid">
            <div class="metric-card">
              <div class="metric-card__label">考试时长</div>
              <div class="metric-card__value">{{ test.totalTime || 0 }} 分钟</div>
            </div>
            <div class="metric-card">
              <div class="metric-card__label">题目数量</div>
              <div class="metric-card__value">{{ assign.length }}</div>
            </div>
            <div class="metric-card">
              <div class="metric-card__label">试卷总分</div>
              <div class="metric-card__value">{{ total }}</div>
            </div>
            <div class="metric-card">
              <div class="metric-card__label">及格分数</div>
              <div class="metric-card__value">{{ passScoreValue }}</div>
            </div>
          </div>

          <div class="notice-panel">
            <div class="notice-panel__title">我已知晓，开始考试前请确认</div>
            <div class="notice-list">
              <div v-for="(item, index) in examNotices" :key="index" class="notice-item">
                <span class="notice-item__index">{{ index + 1 }}</span>
                <span class="notice-item__text">{{ item }}</span>
              </div>
            </div>
          </div>

          <div class="intro-card__actions">
            <el-button plain @click="goTaskList">暂不开始</el-button>
            <el-button type="primary" round icon="el-icon-video-play" @click="startExam">我已知晓，开始考试</el-button>
          </div>
        </div>

        <aside class="panel-card intro-side-card exam-stage exam-stage--side">
          <div class="section-eyebrow">EXAM INFO</div>
          <div class="side-card__title">{{ test.name || '在线考试' }}</div>
          <div class="side-card__group">
            <div class="side-info-item">
              <span>任务名称</span>
              <strong>{{ test.taskName || '新人第一阶段考试' }}</strong>
            </div>
            <div class="side-info-item">
              <span>开始时间</span>
              <strong>{{ test.startTime || '-' }}</strong>
            </div>
            <div class="side-info-item">
              <span>截止时间</span>
              <strong>{{ test.endTime || '-' }}</strong>
            </div>
            <div class="side-info-item">
              <span>当前状态</span>
              <strong>等待开始</strong>
            </div>
          </div>
        </aside>
      </section>

      <template v-else-if="examFlow === 'answering'">
        <section class="exam-overview-card panel-card exam-stage exam-stage--hero">
          <div class="exam-overview-card__topbar">
            <el-button class="exam-return-button" plain size="mini" icon="el-icon-arrow-left" @click="goTaskList">返回列表</el-button>
            <div class="exam-hero__status-group">
              <span class="task-scene-tag">{{ sceneLabel }}</span>
              <span class="status-pill status-pill--active">答题中</span>
            </div>
          </div>

          <div class="exam-overview-card__body">
            <div class="exam-overview-card__timer">
              <div class="exam-overview-card__timer-icon">
                <i class="el-icon-time"></i>
              </div>
              <div class="timer-block__label">剩余时间</div>
              <div class="timer-block__value">{{ remainingTimeText }}</div>
              <div class="timer-block__hint">
                请在倒计时结束前完成作答，超时后系统会自动提交试卷。
              </div>
              <div class="exam-overview-card__timer-tags">
                <span class="timer-chip">已答 {{ answeredCount }}/{{ assign.length }}</span>
                <span class="timer-chip timer-chip--light">待答 {{ unansweredCount }}</span>
              </div>
            </div>

            <div class="exam-overview-card__content">
              <div class="section-eyebrow">ONLINE EXAM</div>
              <h1 class="page-title">{{ pageTitle }}</h1>
              <div class="exam-overview-card__meta">
                <span>总分：{{ total }} 分</span>
                <span class="exam-overview-card__meta-divider">|</span>
                <span>合格分：{{ passScoreValue }} 分</span>
                <span class="exam-overview-card__meta-divider">|</span>
                <span>时长：{{ test.totalTime || 0 }} 分钟</span>
              </div>

              <div class="notice-panel notice-panel--compact">
                <div class="notice-panel__title">考前须知</div>
                <div class="notice-list notice-list--compact">
                  <div v-for="(item, index) in examNotices" :key="index" class="notice-item notice-item--compact">
                    <span class="notice-item__index">{{ index + 1 }}</span>
                    <span class="notice-item__text">{{ item }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="exam-progress-card panel-card exam-stage exam-stage--side">
          <div class="exam-progress-card__top">
            <div>
              <div class="section-eyebrow">ANSWER PROGRESS</div>
              <div class="section-head__title section-head__title--compact">答题进度</div>
            </div>
            <div class="exam-progress-card__value">
              <span class="exam-progress-card__value-main">{{ answeredCount }}</span>
              <span class="exam-progress-card__value-sub">/ {{ assign.length }}</span>
            </div>
          </div>
          <el-progress :percentage="completionPercent" :stroke-width="10" :show-text="false"></el-progress>
          <div class="exam-progress-card__hint">
            已完成 {{ completionPercent }}%，当前第 {{ currentQuestionIndex + 1 }} 题，未作答 {{ unansweredCount }} 题。
          </div>
        </section>

        <section class="exam-body-layout">
          <div class="exam-question-area panel-card exam-stage exam-stage--question">
            <div class="section-head">
              <div>
                <div class="section-eyebrow">QUESTION PANEL</div>
                <div class="section-head__title">题目作答区</div>
              </div>
              <div class="section-head__meta">共 {{ assign.length }} 题 · 当前第 {{ currentQuestionIndex + 1 }} 题</div>
            </div>

            <div class="exam-action-bar">
              <div class="exam-action-bar__left">
                <el-button plain size="mini" icon="el-icon-warning-outline" @click="showExamNotice = true">考试说明</el-button>
              </div>
              <div class="exam-action-bar__right">
                <span class="task-scene-tag">{{ questionTypeLabel(activeQuestion && activeQuestion.type) }}</span>
                <span class="status-pill" :class="isAnswered(activeQuestion) ? 'status-pill--finished' : 'status-pill--pending'">
                  {{ isAnswered(activeQuestion) ? '本题已作答' : '本题待作答' }}
                </span>
              </div>
            </div>

            <transition v-if="activeQuestion" :name="questionTransitionName" mode="out-in">
              <div :key="activeQuestion.id || currentQuestionIndex" class="question-panel">
                <div class="question-panel__header">
                  <div class="question-panel__title-wrap">
                    <span class="question-number">{{ currentQuestionIndex + 1 }}</span>
                    <div>
                      <div class="question-title">{{ activeQuestion.title }}</div>
                      <div class="question-meta-row">
                        <span :class="['question-type-badge', `question-type-badge--${questionTypeClass(activeQuestion.type)}`]">
                          {{ questionTypeLabel(activeQuestion.type) }}
                        </span>
                        <span class="question-score">本题 {{ activeQuestion.score || 0 }} 分</span>
                      </div>
                    </div>
                  </div>
                  <div :class="['answer-status', isAnswered(activeQuestion) ? 'answer-status--success' : 'answer-status--pending']">
                    {{ isAnswered(activeQuestion) ? '已作答' : '未作答' }}
                  </div>
                </div>

                <div class="question-panel__body">
                  <el-radio-group
                    v-if="String(activeQuestion.type) === '0'"
                    v-model="activeQuestion.solution"
                    class="answer-option-group"
                  >
                    <el-radio
                      v-for="(option, optionIndex) in activeQuestion.content"
                      :key="optionIndex"
                      :label="option.value"
                      border
                      class="answer-option-item"
                    >
                      <span class="answer-option-item__tag">{{ option.value }}</span>
                      <span class="answer-option-item__text">{{ option.option }}</span>
                    </el-radio>
                  </el-radio-group>

                  <el-checkbox-group
                    v-else-if="String(activeQuestion.type) === '1'"
                    v-model="activeQuestion.solution"
                    class="answer-option-group"
                  >
                    <el-checkbox
                      v-for="(option, optionIndex) in activeQuestion.content"
                      :key="optionIndex"
                      :label="option.value"
                      border
                      class="answer-option-item"
                    >
                      <span class="answer-option-item__tag">{{ option.value }}</span>
                      <span class="answer-option-item__text">{{ option.option }}</span>
                    </el-checkbox>
                  </el-checkbox-group>

                  <el-input
                    v-else-if="String(activeQuestion.type) === '2'"
                    v-model="activeQuestion.solution"
                    size="small"
                    placeholder="请输入答案"
                  ></el-input>

                  <el-radio-group
                    v-else-if="String(activeQuestion.type) === '3'"
                    v-model="activeQuestion.solution"
                    class="answer-option-group answer-option-group--inline"
                  >
                    <el-radio label="正确" border class="answer-option-item answer-option-item--inline">
                      <span class="answer-option-item__tag answer-option-item__tag--judge">对</span>
                      <span class="answer-option-item__text answer-option-item__text--plain">正确</span>
                    </el-radio>
                    <el-radio label="错误" border class="answer-option-item answer-option-item--inline">
                      <span class="answer-option-item__tag answer-option-item__tag--judge">错</span>
                      <span class="answer-option-item__text answer-option-item__text--plain">错误</span>
                    </el-radio>
                  </el-radio-group>

                  <el-input
                    v-else
                    v-model="activeQuestion.solution"
                    type="textarea"
                    :rows="6"
                    placeholder="请输入答案"
                  ></el-input>
                </div>

                <div class="question-panel__footer">
                  <el-button icon="el-icon-arrow-left" :disabled="currentQuestionIndex <= 0" @click="goPrevQuestion">上一题</el-button>
                  <div class="question-panel__footer-right">
                    <el-button type="primary" plain icon="el-icon-arrow-right" @click="goNextQuestion">
                      {{ currentQuestionIndex >= assign.length - 1 ? '停留本题' : '下一题' }}
                    </el-button>
                  </div>
                </div>
              </div>
            </transition>

            <el-empty v-else description="暂无考试题目" :image-size="100"></el-empty>
          </div>

          <aside class="exam-sidebar panel-card exam-stage exam-stage--sidebar">
            <div class="sidebar-stats-grid">
              <div class="sidebar-stat-card">
                <div class="sidebar-stat-card__label">当前进度</div>
                <div class="sidebar-stat-card__value">{{ completionPercent }}%</div>
              </div>
              <div class="sidebar-stat-card">
                <div class="sidebar-stat-card__label">总分</div>
                <div class="sidebar-stat-card__value">{{ total }}</div>
              </div>
              <div class="sidebar-stat-card">
                <div class="sidebar-stat-card__label">合格分</div>
                <div class="sidebar-stat-card__value">{{ passScoreValue }}</div>
              </div>
              <div class="sidebar-stat-card">
                <div class="sidebar-stat-card__label">待作答</div>
                <div class="sidebar-stat-card__value">{{ unansweredCount }}</div>
              </div>
            </div>

            <div class="section-head section-head--compact">
              <div>
                <div class="section-eyebrow">ANSWER SHEET</div>
                <div class="section-head__title">答题卡</div>
              </div>
            </div>

            <div class="answer-sheet-grid">
              <button
                v-for="(item, index) in assign"
                :key="index"
                type="button"
                :class="[
                  'answer-sheet-item',
                  { 'answer-sheet-item--active': index === currentQuestionIndex },
                  { 'answer-sheet-item--answered': isAnswered(item) },
                  { 'answer-sheet-item--pulse': sheetPulseIndex === index }
                ]"
                :style="{ '--answer-index': index }"
                @click="goQuestion(index)"
              >
                {{ index + 1 }}
              </button>
            </div>

            <div class="answer-sheet-legend">
              <div class="legend-item"><span class="legend-dot legend-dot--active"></span><span>当前题目</span></div>
              <div class="legend-item"><span class="legend-dot legend-dot--answered"></span><span>已作答</span></div>
              <div class="legend-item"><span class="legend-dot"></span><span>未作答</span></div>
            </div>

            <div class="answer-sheet-submit">
              <el-button type="danger" icon="el-icon-finished" @click="submit">提交试卷</el-button>
            </div>
          </aside>
        </section>
      </template>

      <section v-else class="exam-loading-wrap panel-card">
        <div class="exam-loading-wrap__icon">
          <i class="el-icon-loading"></i>
        </div>
        <div class="exam-loading-wrap__title">正在跳转考试结果</div>
        <div class="exam-loading-wrap__desc">试卷提交成功后将直接进入考试结果页，请稍候...</div>
      </section>
    </div>

    <el-dialog title="考试说明" :visible.sync="showExamNotice" width="460px">
      <div class="exam-dialog-list">
        <div v-for="(item, index) in examNotices" :key="index" class="exam-dialog-item">
          <span class="exam-dialog-item__index">{{ index + 1 }}</span>
          <span>{{ item }}</span>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="showExamNotice = false">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getApeTestItemByTestId, saveApeTestStudent } from '../../api/api'

export default {
  name: 'TaskExamDo',
  data() {
    return {
      id: '',
      assign: [],
      test: {},
      total: 0,
      hr: '00',
      min: '00',
      sec: '00',
      timeOut: null,
      five: false,
      ten: false,
      defen: 0,
      end: null,
      currentQuestionIndex: 0,
      pageReady: false,
      examFlow: 'notice',
      questionTransitionName: 'question-slide-next',
      sheetPulseIndex: null,
      sheetPulseTimer: null,
      leaveConfirmed: false,
      examNotices: [
        '单选题、多选题请确认选项后再切换到下一题。',
        '主观题建议先整理答案结构，再统一提交。',
        '提交后将直接进入考试结果页，并可继续查看错题解析。'
      ],
      showExamNotice: false,
      pageLoading: true
    }
  },
  computed: {
    pageTitle() {
      const taskName = this.test.taskName ? `${this.test.taskName} · ` : ''
      return taskName + (this.test.name || '在线考试')
    },
    sceneLabel() {
      return this.test.taskName || '新人第一阶段考试'
    },
    answeredCount() {
      return this.assign.filter(item => this.isAnswered(item)).length
    },
    unansweredCount() {
      return Math.max(0, this.assign.length - this.answeredCount)
    },
    remainingTimeText() {
      return `${this.hr}:${this.min}:${this.sec}`
    },
    activeQuestion() {
      return this.assign[this.currentQuestionIndex] || null
    },
    completionPercent() {
      if (!this.assign.length) {
        return 0
      }
      return Math.min(100, Math.round(this.answeredCount / this.assign.length * 100))
    },
    passScoreValue() {
      return Number(this.test.passScore || this.$route.query.passScore || 60)
    }
  },
  methods: {
    needsLeaveConfirm() {
      return this.examFlow === 'answering' && !this.pageLoading && !this.leaveConfirmed
    },
    confirmLeaveExam() {
      return this.$confirm('当前正在答题，退出后本次答题进度不会被保存，是否确认退出？', '退出提醒', {
        confirmButtonText: '确认退出',
        cancelButtonText: '继续答题',
        type: 'warning'
      }).then(() => true).catch(() => false)
    },
    handleBeforeUnload(event) {
      if (!this.needsLeaveConfirm()) {
        return undefined
      }
      event.preventDefault()
      event.returnValue = ''
      return ''
    },
    async goTaskList() {
      if (this.needsLeaveConfirm()) {
        const confirmed = await this.confirmLeaveExam()
        if (!confirmed) {
          return
        }
        this.leaveConfirmed = true
      }
      this.$router.push(this.$route.query.fromTask === '1' ? '/center/tasks' : '/test')
    },
    goResultPage(replace = false) {
      const route = {
        path: '/testResult',
        query: {
          id: this.id,
          fromTask: this.$route.query.fromTask || '1',
          passScore: this.passScoreValue
        }
      }
      if (replace) {
        this.$router.replace(route)
        return
      }
      this.$router.push(route)
    },
    activatePage() {
      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          this.pageReady = true
        })
      })
    },
    startExam() {
      this.leaveConfirmed = false
      this.examFlow = 'answering'
      this.currentQuestionIndex = 0
      this.five = false
      this.ten = false
      this.end = Date.parse(new Date()) + Number(this.test.totalTime || 120) * 60 * 1000
      clearTimeout(this.timeOut)
      this.countdown()
      this.scrollToTop()
      this.pulseAnswerSheet(0)
    },
    pulseAnswerSheet(index) {
      this.sheetPulseIndex = index
      clearTimeout(this.sheetPulseTimer)
      this.sheetPulseTimer = setTimeout(() => {
        this.sheetPulseIndex = null
      }, 360)
    },
    switchQuestion(index, direction) {
      if (index < 0 || index >= this.assign.length || index === this.currentQuestionIndex) {
        return
      }
      this.questionTransitionName = direction === 'prev' ? 'question-slide-prev' : 'question-slide-next'
      this.currentQuestionIndex = index
      this.pulseAnswerSheet(index)
    },
    goQuestion(index) {
      const direction = index > this.currentQuestionIndex ? 'next' : 'prev'
      this.switchQuestion(index, direction)
    },
    goPrevQuestion() {
      this.switchQuestion(this.currentQuestionIndex - 1, 'prev')
    },
    goNextQuestion() {
      this.switchQuestion(this.currentQuestionIndex + 1, 'next')
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    questionTypeLabel(type) {
      const typeMap = {
        0: '单选题',
        1: '多选题',
        2: '填空题',
        3: '判断题',
        4: '问答题',
        5: '主观题'
      }
      return typeMap[String(type)] || '试题'
    },
    questionTypeClass(type) {
      const typeMap = {
        0: 'single',
        1: 'multiple',
        2: 'blank',
        3: 'judge',
        4: 'qa',
        5: 'essay'
      }
      return typeMap[String(type)] || 'default'
    },
    isAnswered(item) {
      if (!item) return false
      if (Array.isArray(item.solution)) {
        return item.solution.length > 0
      }
      return item.solution !== null && item.solution !== undefined && String(item.solution).trim() !== ''
    },
    getUnansweredQuestionNumbers() {
      return this.assign
        .map((item, index) => (this.isAnswered(item) ? '' : String(index + 1)))
        .filter(Boolean)
    },
    submit() {
      const unansweredNumbers = this.getUnansweredQuestionNumbers()
      const unansweredCount = unansweredNumbers.length
      const message = unansweredCount > 0
        ? `当前还有 ${unansweredCount} 题未作答（第 ${unansweredNumbers.join('、')} 题），确认仍然提交吗？提交后将直接进入考试结果页。`
        : '确定要提交考试内容吗？提交后将直接进入考试结果页。'
      this.$confirm(message, '交卷提醒', {
        confirmButtonText: '确定提交',
        cancelButtonText: '继续作答',
        type: 'warning'
      }).then(() => {
        this.saveExamPaper()
      }).catch(() => {})
    },
    submitEnd() {
      this.$message({
        message: '考试时间已结束，系统正在自动提交试卷...',
        type: 'success'
      })
      this.saveExamPaper()
    },
    saveExamPaper() {
      const list = this.assign.map(item => {
        const payload = { ...item }
        if (String(payload.type) === '1') {
          payload.solution = Array.isArray(payload.solution) ? payload.solution.join(',') : payload.solution || ''
        }
        return payload
      })
      saveApeTestStudent({ list }).then(res => {
        if (res.code === 1000) {
          this.$message({ type: 'success', message: '交卷成功！' })
          clearTimeout(this.timeOut)
          this.leaveConfirmed = true
          this.examFlow = 'redirecting'
          this.goResultPage(true)
        } else {
          this.$message({ type: 'warning', message: res.message || '交卷失败' })
        }
      }).catch(() => {})
    },
    countdown() {
      const now = Date.parse(new Date())
      const msec = this.end - now
      if (msec <= 10 * 60 * 1000 && !this.ten) {
        this.$message('考试时间还剩十分钟')
        this.ten = true
      }
      if (msec <= 5 * 60 * 1000 && !this.five) {
        this.$message('考试时间还剩五分钟')
        this.five = true
      }
      if (msec <= 0) {
        this.hr = '00'
        this.min = '00'
        this.sec = '00'
        this.submitEnd()
        return
      }
      const hr = parseInt(msec / 1000 / 60 / 60 % 24)
      const min = parseInt(msec / 1000 / 60 % 60)
      const sec = parseInt(msec / 1000 % 60)
      this.hr = hr > 9 ? String(hr) : '0' + hr
      this.min = min > 9 ? String(min) : '0' + min
      this.sec = sec > 9 ? String(sec) : '0' + sec
      this.timeOut = setTimeout(() => {
        this.countdown()
      }, 1000)
    },
    getApeTestItemByTestId() {
      this.pageLoading = true
      this.pageReady = false
      getApeTestItemByTestId({ id: this.id }).then(res => {
        if (res.code === 1000) {
          this.assign = res.data.testItem || []
          this.test = res.data.test || {}
          this.total = 0
          this.defen = 0
          this.assign.forEach(item => {
            this.total += Number(item.score || 0)
            this.defen += Number(item.point || 0)
            if (String(item.type) === '0' || String(item.type) === '1') {
              if (item.content) {
                item.content = JSON.parse(item.content)
              }
              if (String(item.type) === '1') {
                item.solution = item.solution ? item.solution.split(',') : []
              }
            }
          })
          const hasSubmittedRecord = this.assign.some(item => item.id)
          if (hasSubmittedRecord || this.$route.query.readonly === '1') {
            this.examFlow = 'redirecting'
            this.goResultPage(true)
          } else if (this.$route.query.autoStart === '1') {
            this.startExam()
          } else {
            this.examFlow = 'notice'
          }
        } else {
          this.$message.warning(res.message || '考试数据加载失败')
        }
      }).catch(() => {
        this.$message.error('考试数据加载失败')
      }).finally(() => {
        this.pageLoading = false
        this.activatePage()
      })
    }
  },
  mounted() {
    this.scrollToTop()
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    const id = this.$route.query.id
    if (id) {
      this.id = id
    }
    this.getApeTestItemByTestId()
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    clearTimeout(this.timeOut)
    clearTimeout(this.sheetPulseTimer)
  },
  beforeRouteLeave(to, from, next) {
    if (!this.needsLeaveConfirm()) {
      next()
      return
    }
    this.confirmLeaveExam().then(confirmed => {
      if (!confirmed) {
        next(false)
        return
      }
      this.leaveConfirmed = true
      next()
    })
  }
}
</script>
<style scoped>
.task-exam-page {
  min-height: 100%;
  padding: 20px 0 36px;
  background: linear-gradient(180deg, #f5f7fa 0%, #eef3f8 100%);
}

.exam-loading-wrap {
  width: min(1280px, calc(100% - 32px));
  margin: 0 auto;
  min-height: 520px;
  padding: 48px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.exam-loading-wrap__icon {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: linear-gradient(180deg, #eef4ff 0%, #e0ecff 100%);
  color: #1a71ff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  box-shadow: inset 0 0 0 1px rgba(26, 113, 255, 0.08);
}

.exam-loading-wrap__title {
  margin-top: 20px;
  color: #1f2d3d;
  font-size: 28px;
  font-weight: 700;
}

.exam-loading-wrap__desc {
  margin-top: 10px;
  color: #64748b;
  font-size: 14px;
}

.exam-loading-skeleton {
  width: min(640px, 100%);
  margin-top: 28px;
  display: grid;
  gap: 12px;
}

.exam-loading-skeleton__block {
  display: block;
  height: 16px;
  border-radius: 999px;
  background: linear-gradient(90deg, #eef2f7 20%, #f8fbff 45%, #eef2f7 70%);
  background-size: 200% 100%;
  animation: exam-loading-shimmer 1.35s ease-in-out infinite;
}

.exam-loading-skeleton__block--lg {
  height: 20px;
  width: 82%;
  justify-self: center;
}

.exam-loading-skeleton__block--sm {
  width: 56%;
  justify-self: center;
}

@keyframes exam-loading-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.exam-shell {
  width: min(1280px, calc(100% - 32px));
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.exam-stage {
  opacity: 0;
  transform: translateY(24px) scale(0.985);
  transition: opacity 0.5s cubic-bezier(0.22, 1, 0.36, 1), transform 0.5s cubic-bezier(0.22, 1, 0.36, 1);
}

.task-exam-page--ready .exam-stage {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.task-exam-page--ready .exam-stage--side {
  transition-delay: 0.08s;
}

.task-exam-page--ready .exam-stage--question {
  transition-delay: 0.12s;
}

.task-exam-page--ready .exam-stage--sidebar {
  transition-delay: 0.18s;
}

.panel-card {
  background: #ffffff;
  border: 1px solid #e6edf6;
  border-radius: 20px;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.05);
}

.panel-card--hero,
.panel-card--side,
.exam-question-area,
.exam-sidebar,
.intro-card,
.intro-side-card,
.exam-status-card {
  padding: 24px;
}

.exam-intro-layout,
.exam-status-layout,
.exam-hero {
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(280px, 0.8fr);
  gap: 18px;
}

.exam-overview-card {
  padding: 24px;
}

.exam-overview-card__topbar,
.exam-overview-card__body {
  display: flex;
  gap: 18px;
}

.exam-overview-card__topbar {
  align-items: center;
  justify-content: space-between;
}

.exam-return-button.el-button {
  min-height: 38px;
  padding: 0 16px;
  border-radius: 999px;
  border: 1px solid #cfddf2;
  background: linear-gradient(180deg, #ffffff 0%, #f5f9ff 100%);
  color: #315891;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  box-shadow: 0 10px 22px rgba(31, 45, 61, 0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, background-color 0.2s ease, color 0.2s ease;
}

.exam-return-button.el-button:hover,
.exam-return-button.el-button:focus {
  border-color: #a7c3ef;
  background: linear-gradient(180deg, #ffffff 0%, #eef5ff 100%);
  color: #1a71ff;
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(26, 113, 255, 0.12);
}

.exam-return-button.el-button:active {
  transform: translateY(0);
  box-shadow: 0 8px 18px rgba(26, 113, 255, 0.1);
}

.exam-return-button /deep/ span {
  display: inline-flex;
  align-items: center;
}

.exam-return-button /deep/ .el-icon-arrow-left {
  margin-right: 6px;
  font-size: 12px;
  transition: transform 0.2s ease;
}

.exam-return-button:hover /deep/ .el-icon-arrow-left,
.exam-return-button:focus /deep/ .el-icon-arrow-left {
  transform: translateX(-2px);
}

.exam-overview-card__body {
  margin-top: 20px;
  align-items: stretch;
}

.exam-overview-card__timer {
  width: 300px;
  flex-shrink: 0;
  border-radius: 18px;
  background: linear-gradient(180deg, #f7faff 0%, #eef4ff 100%);
  border: 1px solid #dbeafe;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.exam-overview-card__timer-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(26, 113, 255, 0.1);
  color: #1a71ff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 38px;
}

.exam-overview-card__timer-tags {
  margin-top: 16px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}

.timer-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  background: #1a71ff;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}

.timer-chip--light {
  background: #e7f0ff;
  color: #1a71ff;
}

.exam-overview-card__content {
  min-width: 0;
  flex: 1;
}

.exam-overview-card__meta {
  margin-top: 6px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  color: #64748b;
  font-size: 14px;
}

.exam-overview-card__meta-divider {
  color: #c0cad6;
}

.notice-panel--compact {
  margin-top: 22px;
}

.notice-list--compact {
  gap: 10px;
}

.notice-item--compact .notice-item__text {
  line-height: 1.7;
}

.exam-progress-card {
  padding: 20px 24px;
}

.exam-progress-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.section-head__title--compact {
  font-size: 22px;
}

.exam-progress-card__value {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  color: #1e293b;
}

.exam-progress-card__value-main {
  font-size: 32px;
  line-height: 1;
  font-weight: 700;
}

.exam-progress-card__value-sub {
  font-size: 16px;
  color: #64748b;
  padding-bottom: 2px;
}

.exam-progress-card__hint {
  margin-top: 12px;
  color: #64748b;
  font-size: 13px;
}

.intro-card__topbar,
.exam-hero__topbar,
.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.exam-hero__status-group {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.section-eyebrow {
  margin-top: 18px;
  color: #1a71ff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
}

.page-title,
.section-head__title {
  margin: 12px 0 10px;
  font-size: 30px;
  line-height: 1.3;
  font-weight: 700;
  color: #1e2f43;
}

.page-desc,
.section-head__meta,
.timer-block__hint,
.metric-card__label,
.timer-block__label,
.timer-meta-item span,
.legend-item span,
.question-score {
  color: #64748b;
  font-size: 13px;
  line-height: 1.8;
}

.intro-card__actions,
.status-card__actions {
  margin-top: 24px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.status-pill,
.task-scene-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.task-scene-tag {
  background: #eef4ff;
  color: #1a71ff;
}

.status-pill--pending {
  background: #eff6ff;
  color: #2563eb;
}

.status-pill--active {
  background: #e8f7ec;
  color: #1f9d55;
}

.status-pill--finished {
  background: #eef2ff;
  color: #4753c8;
}

.exam-summary-grid {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.metric-card {
  padding: 16px;
  border: 1px solid #edf2f7;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.metric-card__value {
  margin-top: 10px;
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
}

.metric-card__value--small {
  font-size: 18px;
  line-height: 1.6;
}

.notice-panel,
.status-progress-card {
  margin-top: 24px;
  padding: 20px;
  border-radius: 18px;
  background: #f8fbff;
  border: 1px solid #dbeafe;
}

.notice-panel__title,
.status-progress-card__title,
.side-card__title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2d3d;
}

.notice-list,
.side-card__group,
.timer-block__meta,
.exam-dialog-list,
.answer-sheet-legend {
  display: grid;
  gap: 12px;
}

.notice-list {
  margin-top: 18px;
}

.notice-item,
.exam-dialog-item,
.legend-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.notice-item__index,
.exam-dialog-item__index {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(26, 113, 255, 0.12);
  color: #1a71ff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.notice-item__text {
  color: #334155;
  line-height: 1.8;
}

.side-info-item,
.timer-meta-item {
  padding: 14px 16px;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #edf2f7;
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.side-info-item strong,
.timer-meta-item strong,
.status-progress-card__row strong {
  color: #1f2d3d;
  font-size: 14px;
}

.timer-block__value {
  margin-top: 10px;
  font-size: 40px;
  font-weight: 700;
  color: #1a71ff;
  letter-spacing: 0.04em;
}

.timer-block__actions,
.exam-action-bar {
  margin-top: 18px;
}

.exam-action-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.exam-action-bar__right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.exam-body-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.72fr) 360px;
  gap: 22px;
  align-items: start;
}

.exam-sidebar {
  position: sticky;
  top: 16px;
}

.sidebar-stats-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}

.sidebar-stat-card {
  padding: 16px 14px;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f7faff 100%);
  border: 1px solid #e5edf7;
}

.sidebar-stat-card__label {
  color: #64748b;
  font-size: 12px;
}

.sidebar-stat-card__value {
  margin-top: 8px;
  color: #1f2d3d;
  font-size: 22px;
  font-weight: 700;
}

.section-head__title {
  margin-top: 6px;
  margin-bottom: 0;
  font-size: 24px;
}

.question-panel {
  margin-top: 18px;
  border: 1px solid #edf2f7;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  padding: 22px;
}

.question-slide-next-enter-active,
.question-slide-next-leave-active,
.question-slide-prev-enter-active,
.question-slide-prev-leave-active {
  transition: opacity 0.28s ease, transform 0.28s ease;
}

.question-slide-next-enter,
.question-slide-prev-leave-to {
  opacity: 0;
  transform: translateX(22px) translateY(6px);
}

.question-slide-next-leave-to,
.question-slide-prev-enter {
  opacity: 0;
  transform: translateX(-22px) translateY(6px);
}

.question-panel__header,
.question-panel__footer {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: flex-start;
}

.question-panel__title-wrap {
  display: flex;
  gap: 14px;
}

.question-number {
  width: 46px;
  height: 46px;
  border-radius: 14px;
  background: linear-gradient(135deg, #1a71ff, #4f8fff);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  flex-shrink: 0;
}

.question-title {
  font-size: 20px;
  font-weight: 700;
  color: #1f2d3d;
  line-height: 1.6;
}

.question-meta-row {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.question-type-badge {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.question-type-badge--single,
.question-type-badge--judge {
  color: #1d4ed8;
  background: #dbeafe;
}

.question-type-badge--multiple {
  color: #6d28d9;
  background: #ede9fe;
}

.question-type-badge--blank,
.question-type-badge--qa,
.question-type-badge--essay,
.question-type-badge--default {
  color: #92400e;
  background: #fef3c7;
}

.answer-status {
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.answer-status--success {
  background: #e8f7ec;
  color: #1f9d55;
}

.answer-status--pending {
  background: #eff6ff;
  color: #2563eb;
}

.question-panel__body {
  margin-top: 24px;
}

.answer-option-group {
  display: grid;
  gap: 14px;
}

.answer-option-group--inline {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.answer-option-item {
  width: 100%;
  margin-right: 0 !important;
}

.answer-option-item.el-radio,
.answer-option-item.el-checkbox {
  display: block;
  margin-right: 0;
  line-height: normal;
  vertical-align: top;
}

.answer-option-item--inline {
  width: 100%;
}

.answer-option-item.el-radio.is-bordered,
.answer-option-item.el-checkbox.is-bordered {
  width: 100%;
  min-height: 66px;
  height: auto;
  margin-left: 0;
  margin-right: 0;
  padding: 14px 18px 14px 16px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border-radius: 18px;
  border-color: #d6e4f7;
  background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.answer-option-item.el-radio.is-bordered:hover,
.answer-option-item.el-checkbox.is-bordered:hover {
  border-color: #9ac0ff;
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(26, 113, 255, 0.1);
}

.answer-option-item.el-radio.is-bordered.is-checked,
.answer-option-item.el-checkbox.is-bordered.is-checked {
  border-color: #1a71ff;
  background: linear-gradient(180deg, #eff6ff 0%, #eaf3ff 100%);
  box-shadow: 0 12px 26px rgba(26, 113, 255, 0.14);
}

.answer-option-item /deep/ .el-radio__input,
.answer-option-item /deep/ .el-checkbox__input {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.answer-option-item /deep/ .el-radio__label,
.answer-option-item /deep/ .el-checkbox__label {
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 14px;
  padding-left: 14px;
  padding-right: 0;
  white-space: normal;
  line-height: 1.7;
  font-size: 15px;
  font-weight: 600;
  color: #243b53;
}

.answer-option-item__tag {
  width: 32px;
  height: 32px;
  border-radius: 12px;
  border: 1px solid #d8e6fb;
  background: #ffffff;
  color: #4b6aa8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 700;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.answer-option-item__tag--judge {
  letter-spacing: 0.08em;
}

.answer-option-item__text {
  flex: 1;
  min-width: 0;
}

.answer-option-item__text--plain {
  font-size: 16px;
}

.answer-option-item /deep/ .el-radio__input.is-checked + .el-radio__label .answer-option-item__tag,
.answer-option-item /deep/ .el-checkbox__input.is-checked + .el-checkbox__label .answer-option-item__tag {
  border-color: #1a71ff;
  background: linear-gradient(135deg, #1a71ff, #5b94ff);
  color: #ffffff;
  box-shadow: 0 10px 20px rgba(26, 113, 255, 0.2);
}

.question-panel__body /deep/ .el-input__inner,
.question-panel__body /deep/ .el-textarea__inner {
  border-radius: 16px;
  border-color: #dbe6f5;
  background: #fbfdff;
}

.question-panel__body /deep/ .el-textarea__inner {
  min-height: 160px;
}

.question-panel__footer {
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid #edf2f7;
  align-items: center;
}

.question-panel__footer-right {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.answer-sheet-grid {
  margin-top: 20px;
  padding: 14px;
  border-radius: 18px;
  border: 1px solid #edf3fb;
  background: linear-gradient(180deg, #fbfdff 0%, #f5f9ff 100%);
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(54px, 1fr));
  gap: 12px;
  align-content: start;
}

.answer-sheet-legend {
  margin-top: 16px;
  padding: 14px 16px;
  border-radius: 16px;
  border: 1px solid #edf3fb;
  background: #f8fbff;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.answer-sheet-submit {
  margin-top: 20px;
  display: flex;
  justify-content: stretch;
}

.answer-sheet-submit /deep/ .el-button {
  width: 100%;
  min-height: 44px;
  border-radius: 14px;
  font-weight: 600;
  box-shadow: 0 12px 24px rgba(234, 92, 92, 0.16);
}

.answer-sheet-item {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  padding: 0;
  border: 1px solid #dbe6f5;
  background: #fff;
  border-radius: 16px;
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.02em;
  color: #4b5f75;
  cursor: pointer;
  outline: none;
  box-shadow: 0 8px 20px rgba(31, 45, 61, 0.05);
  opacity: 0;
  transform: translateY(10px) scale(0.94);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, background-color 0.2s ease, opacity 0.34s ease;
  transition-delay: calc(var(--answer-index) * 0.028s + 0.2s);
}

.answer-sheet-item::after {
  content: '';
  position: absolute;
  right: 8px;
  bottom: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: transparent;
  transition: background-color 0.2s ease;
}

.task-exam-page--ready .answer-sheet-item {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.answer-sheet-item--answered {
  border-color: #8ebfff;
  color: #1a71ff;
  background: linear-gradient(180deg, #ffffff 0%, #f5faff 100%);
}

.answer-sheet-item--answered::after {
  background: #7ab8ff;
}

.answer-sheet-item--active,
.answer-sheet-item--active.answer-sheet-item--answered {
  border-color: #1a71ff;
  background: linear-gradient(135deg, #edf4ff 0%, #e5efff 100%);
  color: #1a71ff;
  box-shadow: 0 12px 24px rgba(26, 113, 255, 0.16);
}

.answer-sheet-item--active::after {
  background: #1a71ff;
}

.answer-sheet-item--pulse {
  animation: answer-sheet-pulse 0.36s ease;
}

@keyframes answer-sheet-pulse {
  0% { transform: scale(0.94); }
  45% { transform: scale(1.08); }
  100% { transform: scale(1); }
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #dbe6f5;
  flex-shrink: 0;
  box-shadow: 0 0 0 4px rgba(219, 230, 245, 0.36);
}

.legend-dot--active {
  background: #1a71ff;
  box-shadow: 0 0 0 4px rgba(26, 113, 255, 0.12);
}

.legend-dot--answered {
  background: #7ab8ff;
  box-shadow: 0 0 0 4px rgba(122, 184, 255, 0.16);
}

.legend-item {
  align-items: center;
}

.legend-item span:last-child {
  white-space: nowrap;
}

.status-progress-card__row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin: 14px 0 12px;
}

.status-progress-card__desc {
  margin-top: 12px;
  color: #64748b;
  font-size: 13px;
}

@media (max-width: 1200px) {
  .exam-intro-layout,
  .exam-status-layout,
  .exam-hero,
  .exam-body-layout {
    grid-template-columns: 1fr;
  }

  .exam-overview-card__body {
    flex-direction: column;
  }

  .exam-overview-card__timer {
    width: 100%;
  }

  .exam-sidebar {
    position: static;
  }

  .exam-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .exam-loading-wrap {
    width: calc(100% - 24px);
    min-height: 420px;
    padding: 36px 18px;
  }

  .exam-loading-wrap__title {
    font-size: 24px;
  }

  .panel-card--hero,
  .panel-card--side,
  .exam-question-area,
  .exam-sidebar,
  .intro-card,
  .intro-side-card,
  .exam-status-card {
    padding: 18px;
  }

  .intro-card__topbar,
  .exam-hero__topbar,
  .exam-overview-card__topbar,
  .exam-progress-card__top,
  .question-panel__header,
  .question-panel__footer,
  .section-head,
  .exam-action-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .page-title,
  .section-head__title {
    font-size: 24px;
  }

  .exam-summary-grid {
    grid-template-columns: 1fr;
  }

  .sidebar-stats-grid {
    grid-template-columns: 1fr 1fr;
  }

  .question-panel {
    padding: 18px;
  }

  .answer-option-group--inline {
    grid-template-columns: 1fr;
  }

  .answer-sheet-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    padding: 12px;
    gap: 10px;
  }

  .answer-sheet-legend {
    grid-template-columns: 1fr;
  }

  .answer-option-item.el-radio.is-bordered,
  .answer-option-item.el-checkbox.is-bordered {
    min-height: 60px;
    padding: 12px 14px;
  }

  .answer-option-item /deep/ .el-radio__label,
  .answer-option-item /deep/ .el-checkbox__label {
    gap: 12px;
    padding-left: 12px;
    font-size: 14px;
  }

  .answer-option-item__tag {
    width: 28px;
    height: 28px;
    border-radius: 10px;
  }

  .answer-sheet-item {
    min-height: 48px;
  }
}
</style>
